<template>
    <filter-by-taxonomies v-model="membersToShow" :content="members" :taxonomies="categories"></filter-by-taxonomies>
    <section v-if="membersToShow.length > 0" class="community__grid mb-5">
        <member v-for="_member in membersToShow" :member="_member"/>
    </section>
    <section v-else class="d-flex flex-column justify-content-center text-center mt-5">
        <div class="space-section__p space-section__p--justify mt-3" style="width: auto;">{{emptyMessage}}</div>
    </section>
</template>
<script>
import Member from "@components/community/member.vue";
import FilterByTaxonomies from "@components/helpers/FilterByTaxonomies.vue";

export default {
    inject: ['locale'],
    components: {FilterByTaxonomies, Member},
    props: {
        members: {type: Array, required: true},
        categories: {type: Array, required: true}
    },
    data: () => ({
        membersToShow: []
    }),
    computed: {
        emptyMessage(){
         return this.locale == 'es' ? 'No se encontraron miembros con esa categoria.' : "No members were found with that category."
        }
    }
}
</script>
<style scoped lang="scss">

</style>